import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=0df99e98&scoped=true"
import script from "./QuestionList.vue?vue&type=script&lang=ts"
export * from "./QuestionList.vue?vue&type=script&lang=ts"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=0df99e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df99e98",
  null
  
)

export default component.exports